import { Form, DatePicker, Row, Col, Input, Button } from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { useEffect } from "react";
import { BiDollar } from "react-icons/bi";
import { BsCurrencyDollar } from "react-icons/bs";
import { TbMoodDollar } from "react-icons/tb";
import "./style.css";
const Index = ({ setActive }) => {
  const [form] = Form.useForm();

  const onSub = async (values) => {
    setActive(true);
    // alert(JSON.stringify(values));
    let res = await fetch(`${process.env.REACT_APP_BASE_URL}/api/new-agents`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(values),
    });
    const { pdfBase64 } = await res.json();
    const byteCharacters = atob(pdfBase64);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(null)
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    console.log("url", url);
    // Create a link element to download the PDF
    const a = document.createElement("a");
    a.href = url;
    a.download = "New Agents"; // Set the desired file name
    document.body.appendChild(a);
    a.click();

    // Clean up
    a.remove();
    window.URL.revokeObjectURL(url);
    setActive(false);
  };

  return (
    <div className="main">
      <Form form={form} onFinish={onSub}>
        <Row gutter={16} justify={"space-evenly"}>
          <Col md={12}>
            <label>Subscriber's Name</label>
            <Form.Item
              name="subscriber_name"
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="Subscriber's Name" />
            </Form.Item>
          </Col>
          <Col md={12}>
            <label>Subscriber's MLS ID</label>
            <Form.Item
              name="mls_id"
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="Subscriber's MLS ID" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} justify={"space-evenly"}>
          <Col md={12}>
            <label>Street Address</label>
            <Form.Item
              name="street_address"
              rules={[{ required: true, message: "required" }]}
            >
              <TextArea
                rows={3}
                style={{ resize: "none" }}
                placeholder="Enter Street Address"
              />
            </Form.Item>
          </Col>
          <Col md={12}>
            <label>City</label>
            <Form.Item
              name="city"
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="City" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} justify={"space-evenly"}>
          <Col md={8}>
            <label>State</label>
            <Form.Item
              name="state"
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="State" />
            </Form.Item>
          </Col>
          <Col md={8}>
            <label>Zip</label>
            <Form.Item
              name="zip"
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="Zip Code" />
            </Form.Item>
          </Col>
          <Col md={8}>
            <label>Telephone #</label>
            <Form.Item
              name="telephone"
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="Telephone #" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} justify={"space-evenly"}>
          <Col md={12}>
            <label>Email Address</label>
            <Form.Item
              name="email"
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="Email" />
            </Form.Item>
          </Col>
          <Col md={12}>
            <label>License #</label>
            <Form.Item
              name="license"
              rules={[{ required: true, message: "required" }]}
            >
              <Input placeholder="License #" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col md={8}>
            <label>Expiration Date</label>
            <Form.Item name="expiration_date">
              <DatePicker />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Index;
